import PageLayout from '../../../../components/layouts/PageLayout';
import { DomStateType, Loading, menuType, ServiceType } from '../../../../utils/helpers/constants';
import InnerMenuLayout from '../../../../components/layouts/InnerMenuLayout';
import SphereLoader from '../../../../components/loaders/SphereLoader';
import Body from './Body';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getDynamicFields } from '../../../../store/actions/component.action';
import { getProfile } from '../../../../store/actions/profile.action';

const VehicleOwnerInfo = () => {
    const dispatch = useDispatch();
    const { profile, component } = useSelector(({ profileReducer, componentReducer }) => ({
        profile: profileReducer,
        component: componentReducer
    }))
    const loadState = !component.dynamicFields[ServiceType.FLT] || profile.domState.vehicleOwnerProfile === null
        || component.loadingDynamicFields !== Loading.SUCCESS;

    useEffect(() => {
        batch(() => {
            if (!component.dynamicFields[ServiceType.FLT]) dispatch(getDynamicFields(ServiceType.FLT));
            if (profile.domState.type === DomStateType.VEHICLE_OWNER && profile.domState.vehicleOwnerProfile === null) dispatch(getProfile());
        });
    }, []);
    

    return (
        <PageLayout active={menuType.PROFILE}>
            <InnerMenuLayout active={menuType.VEHICLE_INFO} type="PROFILE">
                {loadState ? <SphereLoader /> :
                    <Body profile={profile.vehicleOwner} fullProfile={profile} dynamicFields={component.dynamicFields[ServiceType.FLT]}/>
                } 
            </InnerMenuLayout>
        </PageLayout>
    )
}

export default VehicleOwnerInfo